// Sentinel value used in the buyer dropdown for walk-in (manure + bag only).
// Selecting this in the dropdown opens the free-text "buyer_adhoc" field.
// Stored in form state as a string; submit code converts it to buyer: <text>
// + buyer_id: undefined per the backend's adhoc-buyer CHECK constraint
// (see backend/db/migrations/000043_adhoc_buyer_constraint.up.sql).
export const ADHOC_BUYER = "__adhoc__";
